package `fun`.adaptive.cookbook

import `fun`.adaptive.resource.graphics.Graphics
import `fun`.adaptive.resource.graphics.GraphicsResource
import `fun`.adaptive.resource.graphics.GraphicsResourceSet

private object commonMainGraphics0 {

    val dining by lazy { init_dining() }

    val gpp_maybe by lazy { init_gpp_maybe() }

    val lock by lazy { init_lock() }

    val mail by lazy { init_mail() }

    val check by lazy { init_check() }

    val lock_open by lazy { init_lock_open() }

    val add by lazy { init_add() }

    val close by lazy { init_close() }

    val check_circle by lazy { init_check_circle() }

    val frame_inspect by lazy { init_frame_inspect() }

    val grid_view by lazy { init_grid_view() }

    val assignment by lazy { init_assignment() }

    val edit by lazy { init_edit() }

    val menu by lazy { init_menu() }

    val flatware by lazy { init_flatware() }

    val eco by lazy { init_eco() }

}

val Graphics.dining
    get() = commonMainGraphics0.dining

private fun init_dining() =
    GraphicsResourceSet(
        name = "dining",
        GraphicsResource("/fun.adaptive.cookbook/graphics/dining.svg", setOf())
    )

val Graphics.gpp_maybe
    get() = commonMainGraphics0.gpp_maybe

private fun init_gpp_maybe() =
    GraphicsResourceSet(
        name = "gpp_maybe",
        GraphicsResource("/fun.adaptive.cookbook/graphics/gpp_maybe.svg", setOf())
    )

val Graphics.lock
    get() = commonMainGraphics0.lock

private fun init_lock() =
    GraphicsResourceSet(
        name = "lock",
        GraphicsResource("/fun.adaptive.cookbook/graphics/lock.svg", setOf())
    )

val Graphics.mail
    get() = commonMainGraphics0.mail

private fun init_mail() =
    GraphicsResourceSet(
        name = "mail",
        GraphicsResource("/fun.adaptive.cookbook/graphics/mail.svg", setOf())
    )

val Graphics.check
    get() = commonMainGraphics0.check

private fun init_check() =
    GraphicsResourceSet(
        name = "check",
        GraphicsResource("/fun.adaptive.cookbook/graphics/check.svg", setOf())
    )

val Graphics.lock_open
    get() = commonMainGraphics0.lock_open

private fun init_lock_open() =
    GraphicsResourceSet(
        name = "lock_open",
        GraphicsResource("/fun.adaptive.cookbook/graphics/lock_open.svg", setOf())
    )

val Graphics.add
    get() = commonMainGraphics0.add

private fun init_add() =
    GraphicsResourceSet(
        name = "add",
        GraphicsResource("/fun.adaptive.cookbook/graphics/add.svg", setOf())
    )

val Graphics.close
    get() = commonMainGraphics0.close

private fun init_close() =
    GraphicsResourceSet(
        name = "close",
        GraphicsResource("/fun.adaptive.cookbook/graphics/close.svg", setOf())
    )

val Graphics.check_circle
    get() = commonMainGraphics0.check_circle

private fun init_check_circle() =
    GraphicsResourceSet(
        name = "check_circle",
        GraphicsResource("/fun.adaptive.cookbook/graphics/check_circle.svg", setOf())
    )

val Graphics.frame_inspect
    get() = commonMainGraphics0.frame_inspect

private fun init_frame_inspect() =
    GraphicsResourceSet(
        name = "frame_inspect",
        GraphicsResource("/fun.adaptive.cookbook/graphics/frame_inspect.svg", setOf())
    )

val Graphics.grid_view
    get() = commonMainGraphics0.grid_view

private fun init_grid_view() =
    GraphicsResourceSet(
        name = "grid_view",
        GraphicsResource("/fun.adaptive.cookbook/graphics/grid_view.svg", setOf())
    )

val Graphics.assignment
    get() = commonMainGraphics0.assignment

private fun init_assignment() =
    GraphicsResourceSet(
        name = "assignment",
        GraphicsResource("/fun.adaptive.cookbook/graphics/assignment.svg", setOf())
    )

val Graphics.edit
    get() = commonMainGraphics0.edit

private fun init_edit() =
    GraphicsResourceSet(
        name = "edit",
        GraphicsResource("/fun.adaptive.cookbook/graphics/edit.svg", setOf())
    )

val Graphics.menu
    get() = commonMainGraphics0.menu

private fun init_menu() =
    GraphicsResourceSet(
        name = "menu",
        GraphicsResource("/fun.adaptive.cookbook/graphics/menu.svg", setOf())
    )

val Graphics.flatware
    get() = commonMainGraphics0.flatware

private fun init_flatware() =
    GraphicsResourceSet(
        name = "flatware",
        GraphicsResource("/fun.adaptive.cookbook/graphics/flatware.svg", setOf())
    )

val Graphics.eco
    get() = commonMainGraphics0.eco

private fun init_eco() =
    GraphicsResourceSet(
        name = "eco",
        GraphicsResource("/fun.adaptive.cookbook/graphics/eco.svg", setOf())
    )